export default "__VITE_ASSET__iv5p_MAe__"